import React from 'react';
import { Col, ControlLabel, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import { resetServerContext } from 'react-beautiful-dnd';
import FieldGroup from '../../../FieldGroup.jsx';
import { FormError } from '../../../FormError.jsx';
import MultistepFormsFooter from '../../../MultistepFormsFooter.jsx';
import MultistepFormsNav from '../../../headers/FormHeaders/MultistepFormsNav.jsx';
import CheckboxAdapter from '../../../CheckboxAdapter.jsx';

const StepLinkedFilesFrom = (props) => {
  const {
    submitError,
    submitFailed,
    submitting,
    handleSubmit,
    onCreateColumn,
    onDeleteColumn,
    onColumnNameChange,
    onColumnUrlChange,
    data,
    values,
    onBack,
    onCancel,
  } = props;

  resetServerContext();

  return (
    <form onSubmit={handleSubmit}>
      <Row>
        <Col xs={12}>
          <MultistepFormsNav
            activeIndex={4}
            onBack={onBack}
            onSubmit={handleSubmit}
            type="changeStrategy"
          />
        </Col>
      </Row>
      <Row>
        <Col xs={8}>
          <p className="communication-help text-muted m-b-24">
            You can add supporting materials and documentation for your Change
            Strategy using ChangeSync's Linked Files. Think of Linked Files as
            shortcuts to your organization's repositories like Teams,
            SharePoint, or Dropbox.
          </p>
        </Col>
      </Row>

      <Row className="m-b-60">
        <Col xs={12}>
          {data.length
            ? data.map((item, index) => (
                <div key={`add-linked-file-form-${index}`} className="m-b-24">
                  <Row>
                    <Col xs={6}>
                      <div className="linked-file-form">
                        <Field
                          name={`name${index}`}
                          className="m-0"
                          placeholder="Linked file title"
                          type="text"
                          label={`${index + 1} Linked File Title`}
                        >
                          {(props) => (
                            <FieldGroup
                              {...props}
                              value={item[`name${index}`]}
                              onChange={(event) =>
                                onColumnNameChange(event.target.value, index)
                              }
                            />
                          )}
                        </Field>
                        <button
                          type="button"
                          className="btn-delete btn btn-default m-t-28"
                          onClick={() => onDeleteColumn(index)}
                        ></button>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={6}>
                      <Field
                        id={`url${index}`}
                        name={`url${index}`}
                        className="m-0"
                        placeholder="https://"
                        type="text"
                        label="URL"
                      >
                        {(props) => (
                          <FieldGroup
                            {...props}
                            value={item[`url${index}`]}
                            onChange={(event) =>
                              onColumnUrlChange(event.target.value, index)
                            }
                          />
                        )}
                      </Field>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={6}>
                      <ControlLabel>Who Can Access:</ControlLabel>
                      <Field
                        id={`viewer${index}`}
                        name={`viewer${index}`}
                        defaultValue={item[`groupRoles${index}`].includes(
                          'viewer'
                        )}
                        label="Group Viewer"
                        type="checkbox"
                        component={CheckboxAdapter}
                      />
                      <Field
                        id={`change_advocate${index}`}
                        name={`change_advocate${index}`}
                        defaultValue={item[`groupRoles${index}`].includes(
                          'change_advocate'
                        )}
                        label="Change Advocate"
                        type="checkbox"
                        component={CheckboxAdapter}
                      />
                    </Col>
                  </Row>
                </div>
              ))
            : null}
        </Col>
        <Col xs={12}>
          <button
            className="btn-link"
            onClick={(event) => {
              event.preventDefault();
              onCreateColumn();
            }}
          >
            {' '}
            + Add a Linked file
          </button>
        </Col>
      </Row>
      <Row className="m-b-48">
        {submitFailed && submitError ? (
          <FormError submitError={submitError} />
        ) : null}
      </Row>
      <Row>
        <Col xs={12}>
          <MultistepFormsFooter
            values={values}
            loading={submitting}
            handleSubmit={handleSubmit}
            onBack={onBack}
            onCancel={onCancel}
            finalStep
          />
        </Col>
      </Row>
    </form>
  );
};

export default StepLinkedFilesFrom;
